import React, { useEffect, useState } from 'react';
import { useTalentos } from '../../../../application/talentos/hooks/useTalentos';
import ToolbarComponent from '../../../ui/section';
import DynamicTable from '../../../ui/table2';
import Loader from '../../../ui/loader';
import { ModalConfirm } from '../../../ui/modal2';
import FloatingButton from '../../../ui/floatButton';
import { IconButton } from '../../../ui/button';

const JobsPage = (props) => {
    const {
        getJobs,
        deleteJob,
        isLoading,
        error
    } = useTalentos();

    const [jobs, setJobs] = useState([]);
    const [removeModal, setRemoveModal] = useState(false);
    const [currentId, setCurrentId] = useState(null);

    const columns = [
        { key: 'title', label: 'Título', style: { width: "30%" } },
        { key: 'company', label: 'Compañía', style: { width: "20%" } },
        { key: 'category', label: 'Categoría', style: { width: "15%" } },
        { key: 'country', label: 'País', style: { width: "10%" } },
        { key: 'city', label: 'Ciudad', style: { width: "10%" } },
        { key: 'status', label: 'Estado', style: { width: "10%" } },
        { key: 'actions', label: 'Acciones' }
    ];

    const customElements = {
        company: (data) => {
            if (typeof data.company === 'object' && data.company?.name) {
                return <span>{data.company.name}</span>;
            }
            return <span>-</span>;
        },
        status: (data) => {
            const statusColors = {
                active: '#10B981',
                closed: '#EF4444',
                expired: '#F59E0B'
            };
            const statusLabels = {
                active: 'Activo',
                closed: 'Cerrado',
                expired: 'Expirado'
            };
            return (
                <span style={{ 
                    color: statusColors[data.status] || '#6B7280',
                    fontWeight: 600
                }}>
                    {statusLabels[data.status] || data.status}
                </span>
            );
        },
        actions: (data) => (
            <div style={{ display: 'flex', gap: '8px' }}>
                <IconButton onClick={() => handleView(data._id)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.58 12C15.58 13.98 13.98 15.58 12 15.58C10.02 15.58 8.42004 13.98 8.42004 12C8.42004 10.02 10.02 8.42004 12 8.42004C13.98 8.42004 15.58 10.02 15.58 12Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12 20.27C15.53 20.27 18.82 18.19 21.11 14.59C22.01 13.18 22.01 10.81 21.11 9.39997C18.82 5.79997 15.53 3.71997 12 3.71997C8.46997 3.71997 5.17997 5.79997 2.88997 9.39997C1.98997 10.81 1.98997 13.18 2.88997 14.59C5.17997 18.19 8.46997 20.27 12 20.27Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </IconButton>
                <IconButton onClick={() => handleDelete(data._id)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M18.85 9.14001L18.2 19.21C18.09 20.78 18 22 15.21 22H8.79002C6.00002 22 5.91002 20.78 5.80002 19.21L5.15002 9.14001" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10.33 16.5H13.66" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M9.5 12.5H14.5" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </IconButton>
            </div>
        )
    };

    useEffect(() => {
        loadJobs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadJobs = async () => {
        try {
            const data = await getJobs({});
            
            if (!data || data.length === 0) {
                const dataWithLimit = await getJobs({ limit: 50, skip: 0 });
                setJobs(Array.isArray(dataWithLimit) ? dataWithLimit : []);
            } else {
                setJobs(Array.isArray(data) ? data : []);
            }
        } catch (err) {
            console.error('Error al cargar trabajos:', err);
        }
    };

    const handleView = (id) => {
        props.history.push(`/talentos/jobs/${id}`);
    };

    const handleDelete = (id) => {
        setCurrentId(id);
        setRemoveModal(true);
    };

    const handleRemoveConfirm = async () => {
        if (currentId) {
            try {
                await deleteJob(currentId);
                await loadJobs();
                setRemoveModal(false);
                setCurrentId(null);
            } catch (err) {
                console.error('Error al eliminar trabajo:', err);
            }
        }
    };

    return (
        <>
            <ToolbarComponent label="Trabajos" showBackButton={false}>
                {error && (
                    <div style={{ padding: '10px', background: '#FEE2E2', color: '#DC2626', borderRadius: '4px', marginBottom: '16px' }}>
                        {error}
                    </div>
                )}
                <DynamicTable
                    headers={columns}
                    data={jobs}
                    customElements={customElements}
                    fullPage={true}
                    showLabel={false}
                    loaderComponent={<Loader text="Cargando trabajos" />}
                    isLoading={isLoading}
                />
            </ToolbarComponent>
            <ModalConfirm 
                isOpen={removeModal} 
                onClose={() => setRemoveModal(false)} 
                onAccept={handleRemoveConfirm}
                title="¿Eliminar trabajo?"
                message="Esta acción no se puede deshacer."
            />
        </>
    );
};

export default JobsPage;

